import React from "react";
import "./index.scss";

interface IProps {
  size?: "small" | "medium";
}

const Loader: React.FC<IProps> = ({ size = "" }) => {
  return <div className={`loader ${size}`}></div>;
};

export default Loader;
